"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserContext = exports.getUser = exports.exportInstallData = void 0;
const react_1 = __importDefault(require("react"));
const SapporoUser_1 = require("@sapporogo/core/SapporoUser");
const luxon_1 = require("luxon");
const QueryTypes_1 = require("../storage/QueryTypes");
let savingDeviceData = false;
const getFSUser = (firebase, id) => __awaiter(void 0, void 0, void 0, function* () {
    const path = `users/${id}`;
    const user = yield firebase.getDoc(path);
    if (user) {
        user.data.hideAds = user.data.hideAds || false;
    }
    return user;
});
const getNewDisplayName = (firebase) => __awaiter(void 0, void 0, void 0, function* () {
    let query = new QueryTypes_1.SapporoQuery('opennames');
    query.orderBy = new QueryTypes_1.SapporoQueryOrderBy('when', 'asc');
    query.limit = new QueryTypes_1.SapporoQueryLimit(1);
    const queryResults = yield firebase.query(query);
    const { data } = queryResults;
    if (data && data.length > 0) {
        const name = data[0];
        yield firebase.deleteDoc(name.ref.path);
        return name === null || name === void 0 ? void 0 : name.data.name;
    }
    return undefined;
});
const upsertUser = (firebase, authUser) => __awaiter(void 0, void 0, void 0, function* () {
    if (authUser && authUser.uid) {
        const user = new SapporoUser_1.SapporoUser();
        user.uid = authUser.uid;
        if (authUser.isAnonymous) {
            user.isAnonymous = true;
        }
        if (authUser.email) {
            user.email = authUser.email;
        }
        if (authUser.displayName) {
            console.log('AUTH USER DISPLAY NAME:', authUser.displayName);
            user.displayName = authUser.displayName;
        }
        else {
            const displayNameForNewUser = yield getNewDisplayName(firebase);
            user.displayName = displayNameForNewUser;
            console.log('NO AUTH USER DISPLAY NAME:', user.displayName, displayNameForNewUser);
        }
        const userDB = firebase.userToDB(user);
        userDB.createdAt = firebase.serverTimestampValue();
        const path = `users/${authUser.uid}`;
        yield firebase.upsert(path, userDB, true);
        return yield getFSUser(firebase, authUser.uid);
    }
    else {
        return undefined;
    }
});
const exportInstallData = (firebase, user, location) => __awaiter(void 0, void 0, void 0, function* () {
    const now = new Date();
    if (!savingDeviceData) {
        savingDeviceData = true;
        const devData = yield firebase.getDeviceData();
        if (devData) {
            const { deviceUniqueID, brand, buildNumber, bundleId, deviceId, deviceType, model, version, systemName, systemVersion, tablet, notch, emulator, installTime, fontScale, lastUpdateTime, featureSet, } = devData;
            const metaData = {
                deviceUniqueID,
                brand,
                buildNumber,
                bundleId,
                deviceId,
                deviceType,
                model,
                version,
                systemName,
                systemVersion,
                tablet,
                notch,
                emulator,
                updatedAt: now,
                installTime: luxon_1.DateTime.fromMillis(installTime).toJSDate(),
                fontScale,
                lastUpdateTime: luxon_1.DateTime.fromMillis(lastUpdateTime).toJSDate(),
                featureSet,
            };
            const metaDataOutput = firebase.metaDataToDB(metaData, location);
            const collectionPath = `users/${user.uid}/metadata`;
            const query = new QueryTypes_1.SapporoQuery(collectionPath);
            query.addWhere(new QueryTypes_1.SapporoWhereQuery('deviceUniqueID', '==', deviceUniqueID));
            const queryResults = yield firebase.query(query);
            const { data } = queryResults;
            if (data && data.length > 0) {
                const path = data[0].ref.path;
                yield firebase.upsert(path, metaDataOutput, true);
            }
            else {
                metaDataOutput.createdAt = now;
                yield firebase.upsert(collectionPath, metaDataOutput, true);
            }
        }
        savingDeviceData = false;
    }
    else {
        //console.log('SKIPPING THE LOGGING SAVE');
    }
});
exports.exportInstallData = exportInstallData;
const getUser = (firebase, userState) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        let authUserState = userState;
        if (!authUserState) {
            authUserState = yield firebase.signInAsAnonymous();
        }
        let user = yield getFSUser(firebase, authUserState.uid);
        if (!user ||
            !user.data.displayName ||
            authUserState.isAnonymous !== user.data.isAnonymous) {
            user = yield upsertUser(firebase, authUserState);
        }
        if (user) {
            let time = user.data && user.data.createdAt && !!user.data.createdAt.toJSDate
                ? user.data.createdAt.toJSDate()
                : undefined;
            if (!time) {
                time = user.data && user.data.createdAt
                    ? user.data.createdAt.toDate()
                    : new Date();
            }
            return new SapporoUser_1.SapporoUser(luxon_1.DateTime.fromJSDate(time), user.id, user.data.displayName, user.data.email, user.data.emailVerified, user.data.phoneNumber, user.data.photoURL, user.data.defaultLocation, user.data.isAnonymous, user.data.hideAds || false);
        }
        return undefined;
    }
    catch (err) {
        console.log('FAIL', err);
        return undefined;
    }
});
exports.getUser = getUser;
exports.UserContext = react_1.default.createContext(undefined);
